import React, { useContext } from "react";
import GoalContext from "../../store/goal-context";
import classes from "./GoalHeader.module.scss";
import colourClasses from "../../colour.module.scss";

const GoalHeader = () => {
  const goalContext = useContext(GoalContext);
  let setColour = "colour--black";
  let accentColour = "colour--black--accent";
  let activeGoalInfo = null;
  if (goalContext.activeGoal !== null) {
    activeGoalInfo = goalContext.goals[goalContext.activeGoal - 1];
    setColour = activeGoalInfo.primary_colour ? `colour--${activeGoalInfo.primary_colour}` : "colour--black";
    accentColour = activeGoalInfo.secondary_colour ? `colour--${activeGoalInfo.secondary_colour}` : "colour--black--accent";
  }

  return (
    <div id='goal-header' className={`${classes.goalHeader} ${colourClasses[setColour]} ${colourClasses.goalHeader} ${goalContext.activeGoal !== null ? classes.active : ""}`}>
        {activeGoalInfo && (
        <>
        <div className={classes["info-holder"]}>
            <div className={`${classes.number} ${colourClasses[accentColour]}`}>{goalContext.activeGoal}</div>
            <div className={classes["content-wrapper"]}>
                <h2 className={classes.title}>{activeGoalInfo.short_title}</h2>
                <p className={classes.objective}>{activeGoalInfo.description}</p>
            </div>
          </div>
         <img className={classes['mobile-image']} src={activeGoalInfo.goal_desktop_image} alt={activeGoalInfo.short_title} />
         </>
        )}
    </div>
  );
};

export default GoalHeader;
